import { useState } from 'react';
import { Box, Button, Modal, Icon, Card, Table, InterestRate as VoInterestRate } from 'vopay';
import styles from './AnnualRatesModal.module.scss';
import { Title } from 'UI';

type InterestAccountProps = {
  visible: boolean;
  onClose: () => void;
  InterestRates: VoInterestRate[];
  currency: string;
};

interface InterestRate {
  AnnualInterestRate: string;
  Term: string;
  RangeStart: string;
  RangeEnd: string;
}

const AnnualRatesModal: React.FC<InterestAccountProps> = ({ visible, onClose, InterestRates, currency }) => {
  const [isLongTerm, setIsLongTerm] = useState(true);

  return (
    <Modal size="md" isVisible={visible} enableBgClick={false}>
      <div className={styles.annualRatesContainer}>
        <Box width="100%" jc="sb">
          <Title level="3">Annual Rates</Title>

          <Icon
            onClick={() => {
              onClose();
            }}
            color="none"
            bgColor="none"
            icon="cross"
            size="sm"
          />
        </Box>

        <Card
          style={{
            padding: '0',
            borderRadius: 10,
          }}
        >
          <Box p="sm" ai="fe" className={styles.descriptionContainer} gap="sm">
            <Button
              id="create-interest-account-short-term-rate"
              label="Short Term"
              color={isLongTerm ? 'none' : 'primary'}
              type="button"
              background={isLongTerm ? 'none' : ''}
              borderColor={isLongTerm ? 'none' : ''}
              textColor={isLongTerm ? 'rgba(45, 45, 45, 0.8)' : ''}
              width="120px"
              size="sm"
              onClick={() => {
                setIsLongTerm(false);
              }}
            />
            <Button
              id="create-interest-account-long-term-rate"
              label="Long Term"
              color={isLongTerm ? 'primary' : 'none'}
              type="button"
              background={isLongTerm ? '' : 'none'}
              borderColor={isLongTerm ? '' : 'none'}
              textColor={isLongTerm ? '' : 'rgba(45, 45, 45, 0.8)'}
              width="120px"
              size="sm"
              onClick={() => {
                setIsLongTerm(true);
              }}
            />
          </Box>
        </Card>

        <Table
          version="2"
          zebra
          rows={
            InterestRates
              ? (Object.entries(InterestRates) as unknown as [string, InterestRate][])
                  .filter(([_key, value]) => {
                    if (isLongTerm) {
                      return value.Term === 'long-term';
                    }
                    return value.Term === 'short-term';
                  })
                  .map(([_key, value], index) => {
                    return {
                      id: index,
                      data: {
                        AnnualInterestRate: value.AnnualInterestRate ?? '',
                        Range: `${value.RangeStart} - ${value.RangeEnd}`,
                      },
                    };
                  })
              : []
          }
          columns={[
            {
              id: 'range',
              header: 'Range',
              align: 'left',
              template: ({ data }) => (
                <div className={styles.range}>
                  {currency} {data.Range}
                </div>
              ),
            },
            {
              id: 'interest-rate',
              header: 'Annual Interest Rate',
              align: 'center',
              template: ({ data }) => <div className={styles.rate}>{data.AnnualInterestRate}%</div>,
            },
          ]}
          style={{
            '--headerBackground': 'none',
          }}
        />
      </div>
    </Modal>
  );
};

export default AnnualRatesModal;
